import app from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAkb2GLgVKBAmo_joEi3SpR4iF2Cd0ERC0",
  authDomain: "scromble.firebaseapp.com",
  databaseURL: "https://scromble.firebaseio.com",
  projectId: "scromble",
  storageBucket: "scromble.appspot.com",
  messagingSenderId: "861283133160",
  appId: "1:861283133160:web:60f90bb83263ce8eb94b5d"
};

app.initializeApp(firebaseConfig);

require("firebase/database");
export const db = app.database();

require("firebase/functions");
export const functions = app.functions();

require("firebase/auth")
export const auth = app.auth();

// import Auth from 'firebase-auth-lite';
// export const auth = new Auth({
// 	apiKey: firebaseConfig.apiKey
// });

const authui = require("firebaseui").auth.AuthUI;
export const ui = new authui(auth);

export const uiConfig = {
  signInOptions: [
    app.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
  signInSuccessUrl: ".",
};
